<template>
  <div class="product-details-content-setup-step-04">
    <div class="row justify-content-between">
      <div class="col-lg-4">
        <b-tabs>
          <b-tab title="Texto" active>
            <div class="d-flex flex-column gap-4 pt-4">
              <snow-select
                v-model="form.metadata_certification.typography"
                id="typography"
                label="Tipografia"
                :options="typography"
              />
              <snow-input
                v-model="form.name_course"
                id="name_course"
                label="Nome do curso"
                :errors="errors.name_course"
                :required="form.certificate_enabled"
              />
              <snow-input
                v-model="form.hourly_load"
                id="hourly_load"
                label="Carga horária"
                mask="#####"
                :errors="errors.hourly_load"
                :required="form.certificate_enabled"
              />
              <form-group
                v-model="form.metadata_certification.text_color"
                class="text-color"
                id="text_color"
                label="Cor do texto"
                color
              />
            </div>
          </b-tab>
          <b-tab title="Assinatura">
            <div class="d-flex flex-column gap-4 pt-4">
              <div class="text-dark-40 fs-12">
                Caso não seja adicionada uma assinatura, o nome do organizador
                será usado.
              </div>
              <snow-switch
                v-model="useSignature"
                label="Adicionar assinatura"
              />
              <snow-input
                v-model="form.organizer_name"
                id="organizer_name"
                label="Nome do organizador"
                :errors="errors.organizer_name"
                :required="form.certificate_enabled"
                :limit="85"
                lock
              />
              <snow-select
                label="Tipografia (assinatura)"
                id="signature-typography"
                v-if="!useSignature"
                :options="signatureTypography"
                v-model="form.metadata_certification.signature_typography"
              />
              <snow-input-file
                v-if="useSignature"
                v-model="form.image_signature"
                id="image-signature"
                isImage
                backgroundColor="bg-1"
                title="Imagem da assinatura"
              />
            </div>
          </b-tab>
          <b-tab title="Personalizar">
            <div class="d-flex flex-column gap-4 pt-4">
              <small class="text-dark-40 fs-12">
                Ou você pode adicionar uma imagem para ser usada como um
                template.
              </small>
              <snow-switch
                v-model="customBackground"
                id="add-template"
                label="Adicionar um template"
              />
              <div
                v-if="!customBackground"
                class="d-flex flex-column align-items-start gap-4"
              >
                <form-group
                  v-model="form.metadata_certification.color_1"
                  id="color1"
                  label="Cor base"
                  color
                />
                <form-group
                  v-model="form.metadata_certification.color_2"
                  id="color2"
                  label="Cor secundária"
                  color
                />
                <snow-button
                  variant="gray"
                  size="sm"
                  icon="ph ph-arrow-u-up-left"
                  text="Voltar a cor padrão"
                  @click="resetColor"
                />
              </div>
              <div v-if="customBackground">
                <snow-input-file
                  id="certificate-background-image"
                  v-model="form.certificate_background_image"
                  isImage
                  backgroundColor="bg-1"
                  title="Imagem do template"
                />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-lg-7 mt-lg-0 mt-4">
        <certificate-preview
          :courseName="form.name_course"
          :hourly_load="form.hourly_load"
          :organizer_name="form.organizer_name"
          :image_signature="form.image_signature"
          :color_1="form.metadata_certification.color_1"
          :color_2="form.metadata_certification.color_2"
          :typography="form.metadata_certification.typography"
          :template="form.certificate_background_image"
          :textColor="form.metadata_certification.text_color"
          :signature_typography="
            form.metadata_certification.signature_typography
          "
        />
        <div class="d-flex justify-content-end w-100 mt-2">
          <small class="text-dark-40 fs-12">
            Certificado com dimensão A4 ( 297 x 210 ).
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CertificatePreview from "./CertificatePreview.vue";

export default {
  components: { CertificatePreview },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    typography: {
      type: Array,
      default: () => [
        { id: "Poppins", name: "Poppins" },
        { id: "Bellota", name: "Bellota" },
        { id: "Great Vibes", name: "Great Vibes" },
        { id: "Poiret One", name: "Poiret One" },
        { id: "Parisienne", name: "Parisienne" },
        { id: "Simonetta", name: "Simonetta" },
        { id: "Voces", name: "Voces" }
      ]
    }
  },
  data() {
    return {
      customBackground: !!this.form.certificate_background_image,
      useSignature: !!this.form.image_signature,
      imageSignature: this.form.image_signature,
      signatureTypography: [
        { id: "", name: "Padrão" },
        { id: "Whisper", name: "Whisper" },
        { id: "Allison", name: "Allison" },
        { id: "Ms Madi", name: "Ms Madi" }
      ]
    };
  },
  components: {
    CertificatePreview
  },
  methods: {
    resetColor() {
      this.form.metadata_certification.color_1 = "#0047A3";
      this.form.metadata_certification.color_2 = "#001025";
      // this.form.metadata_certification.text_color = "#6E6E6E";
    }
  },
  watch: {
    customBackground(v) {
      if (!v) this.form.certificate_background_image = null;
    },
    useSignature(v) {
      if (!v) this.form.image_signature = null;
      else this.form.image_signature = this.imageSignature;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-details-content-setup-step-04 {
  ::v-deep button.color-button {
    top: 23px;
    min-height: 20px;
    min-width: 20px;
  }

  ::v-deep .form-group #color1 #color2 {
    padding: 0px;
  }

  ::v-deep .form-control,
  #color1 {
    font-size: 13px;
  }

  ::v-deep .form-group .color-picker {
    padding-top: 10px;
  }

  ::v-deep .vc-chrome {
    font-family: unset;
  }

  ::v-deep .vc-chrome-fields-wrap {
    display: none !important;
  }

  ::v-deep .vc-chrome-alpha-wrap {
    display: none !important;
  }

  ::v-deep .vc-chrome-color-wrap {
    display: none !important;
  }
  ::v-deep .nav-link {
    padding: 3.4px;
    margin-bottom: -1px;
  }
  ::v-deep .form-group {
    padding: 0px;
    width: 100%;
    label {
      font-size: 12px;
      color: var(--dark-40);
    }
    input {
      border-radius: 12px;
      border-color: var(--dark-10);
    }
    .color-button {
      top: 44px;
    }
  }
}
</style>
